export const itemRoutes = {
  'inicio': '/dashboard',
  'gestion-alumnas-datos': '/clients',
  'gestion-alumnas-usuarios': '/usuarios',
  'gestion-alumnas-estado': '/clients',
  'gestion-clases-clases': '/classes',
  'gestion-clases-horarios': '/classes',
  'gestion-clases-cupos': '/classes',
  'gestion-asistencias-registro': '/attendance',
  'gestion-asistencias-historial': '/attendance',
  'entrenamiento-rutinas': '/rutinas',
  'entrenamiento-objetivos': '/objetivos',
  'entrenamiento-progreso': '/progreso',
  'bienestar-emocional': '/bienestar',
  'bienestar-habitos': '/bienestar',
  'bienestar-motivacion': '/bienestar',
  'admin-pagos': '/payments',
  'admin-reportes': '/reportes',
  'comunicacion-mensajes': '/mensajes',
  'comunicacion-whatsapp': '/whatsapp',
  'config-datos': '/configuracion',
  'config-usuarios': '/usuarios',
  'config-preferencias': '/configuracion',
  'config-general': '/configuracion'
}

export const siderItems = [
  { key: 'inicio', icon: <span style={{ fontSize: 15 }}>🏠</span>, label: 'Inicio' },
  {
    key: 'gestion',
    icon: <span style={{ fontSize: 15 }}>👥</span>,
    label: 'Gestión',
    children: [
      {
        key: 'gestion-alumnas',
        label: 'Alumnas',
        children: [
          { key: 'gestion-alumnas-datos', label: 'Datos de alumnas' },
          { key: 'gestion-alumnas-usuarios', label: 'Usuarios y claves' },
          { key: 'gestion-alumnas-estado', label: 'Estado / membresía' }
        ]
      },
      {
        key: 'gestion-clases',
        label: 'Clases',
        children: [
          { key: 'gestion-clases-clases', label: 'Clases' },
          { key: 'gestion-clases-horarios', label: 'Horarios' },
          { key: 'gestion-clases-cupos', label: 'Cupos' }
        ]
      },
      {
        key: 'gestion-asistencias',
        label: 'Asistencias',
        children: [
          { key: 'gestion-asistencias-registro', label: 'Registro de asistencias' },
          { key: 'gestion-asistencias-historial', label: 'Historial' }
        ]
      }
    ]
  },
  {
    key: 'entrenamiento',
    icon: <span style={{ fontSize: 15 }}>🏋️</span>,
    label: 'Entrenamiento',
    children: [
      { key: 'entrenamiento-rutinas', label: 'Rutinas' },
      { key: 'entrenamiento-objetivos', label: 'Objetivos' },
      { key: 'entrenamiento-progreso', label: 'Progreso' }
    ]
  },
  {
    key: 'bienestar',
    icon: <span style={{ fontSize: 15 }}>💜</span>,
    label: 'Bienestar',
    children: [
      { key: 'bienestar-emocional', label: 'Estado emocional' },
      { key: 'bienestar-habitos', label: 'Hábitos' },
      { key: 'bienestar-motivacion', label: 'Motivación' }
    ]
  },
  {
    key: 'admin',
    icon: <span style={{ fontSize: 15 }}>💰</span>,
    label: 'Administración',
    children: [
      { key: 'admin-pagos', label: 'Pagos' },
      { key: 'admin-reportes', label: 'Reportes' }
    ]
  },
  {
    key: 'comunicacion',
    icon: <span style={{ fontSize: 15 }}>💬</span>,
    label: 'Comunicación',
    children: [
      { key: 'comunicacion-mensajes', label: 'Mensajes' },
      { key: 'comunicacion-whatsapp', label: 'WhatsApp' }
    ]
  },
  {
    key: 'config',
    icon: <span style={{ fontSize: 15 }}>⚙️</span>,
    label: 'Configuración',
    children: [
      { key: 'config-datos', label: 'Datos del gimnasio' },
      { key: 'config-usuarios', label: 'Usuarios y permisos' },
      { key: 'config-preferencias', label: 'Preferencias' },
      { key: 'config-general', label: 'Configuración general' }
    ]
  }
]

const parentKeys = {}
function walk(items, parent) {
  items.forEach(it => {
    if (it.children) {
      parentKeys[it.key] = parent
      walk(it.children, it.key)
    } else {
      parentKeys[it.key] = parent
    }
  })
}
walk(siderItems, null)

export function getOpenKeys(selected) {
  const keys = []
  let cur = selected
  while (cur && parentKeys[cur]) {
    const p = parentKeys[cur]
    keys.push(p)
    cur = p
  }
  return keys
}

export function findKeyForRoute(pathname) {
  return Object.keys(itemRoutes).find(k => itemRoutes[k] === pathname)
}
